import { type RouteObject } from 'react-router';

export const routes: RouteObject[] = [
    {
        path: '',
        lazy: async () => {
            const { Layout } = await import('@@routes/placement');

            return {
                element: <Layout />,
            };
        },
        children: [
            {
                path: 'history/:metadataId',
                lazy: async () => {
                    const { PlacementHistoryRoute } = await import('@@routes/placementHistory');

                    return { Component: PlacementHistoryRoute };
                },
            },
            {
                path: ':tenantId/category/:categoryId/sections/:sectionId',
                lazy: async () => {
                    const { CategorySectionModal } =
                        await import('@@routes/placement/components/SectionModal/CategorySectionModal');

                    return { Component: CategorySectionModal };
                },
            },
            {
                path: ':tenantId/tag/:tagId/sections/:sectionId',
                lazy: async () => {
                    const { TagSectionModal } =
                        await import('@@routes/placement/components/SectionModal/TagSectionModal');

                    return { Component: TagSectionModal };
                },
            },
        ],
    },
];
